import React, { Component } from 'react'
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import OrderDetailForm from './OrderDetailForm';

class CheckoutCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_id: this.props.match.params.id,
            order: null,
            shippingAddress: {
                shipping_option: '',
                shipping_account_no: '',
                print_location: '',
                print_currency: '',
                special_instructions: '',
                address: {
                    country_id: '',
                    country: ''
                }
            },
            billingAddress: {
                shipped_date: new Date(),
                tracking_number: '',
                billing_status: '',
                comments: '',
                address: {
                    country_id: '',
                    country: ''
                }
            },
            states: [],
            checked: false,
            submitted: false,
            selectedBrand: null,
            selectedTaglayout: null,
            cart: null,
            filtered: "",
            cartProductspageSize: 5,
            productsData: []
        }

        this.child = React.createRef();
    }

    componentDidMount = () => {

        if (this.props.match.params.cart_id) {
            this.props.getCartCall(this.props.match.params.cart_id).then(response => {
                const brand = response.cart.brand_detail;
                brand.logo_path = response.cart.logo_path;
                brand.brand_id = brand.id;

                this.setState({
                    selectedBrand: brand,
                    selectedTaglayout: response.cart.tag_layout_attributes,
                    cart: response.cart.cart,
                    cart_id: this.props.match.params.cart_id,
                    productAttributes: response.cart.product_attributes,
                    orderAttributes: response.cart.order_attributes,
                    exportAttributes: response.cart.exportAttributes,
                    selectedFilterAttributes: response.cart.selected_filters,
                    step: 5
                });
            });
        }
    }

    productsPaginationData = (page, filter, sort, pageSize) => {
        this.setState({ cartProductspageSize: pageSize }, function () {
            this.props.getOrderProductsCall(this.state.order_id).then(response => {
                this.setState({
                    ...this.state,
                    productsData: this.props.productsData
                });
            });
        });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.cart != null &&
                    <React.Fragment>
                        <OrderDetailForm
                            hasShippingAddresses={true}
                            hasBillingAddresses={true}
                            productAttributes={this.state.productAttributes}
                            orderAttributes={this.state.orderAttributes}
                            exportAttributes={this.state.exportAttributes}
                            selectedTaglayout={this.state.selectedTaglayout}
                            selectedBrand={this.state.selectedBrand}
                            cart={this.state.cart}
                            filterAttributes={this.state.filterAttributes}
                            selectedFilterAttributes={
                                this.state.selectedFilterAttributes
                            }
                            CheckoutCartProp={this.state.order}
                            showViewCart="true"
                            fromCartPage="true"
                            canChangeStatus="false"
                        />
                    </React.Fragment>
                }

            </React.Fragment>
        )
    }
}
const mapDispatchToProps = dispatch => {
    return ({
        getCartCall: (id) => {
            return dispatch(
                createOrderActions.getCart(id)
            );
        },
        getOrderProductsCall: (id) => {
            return dispatch(createOrderActions.getOrderProductsPagination(id));
        },
    });
};

function mapStateToProps(state) {
    const { order } = state.ordersReducer;

    const {
        productsData,
        pages,
        current_page,
        total_orders
    } = state.createOrdersReducer;

    return {
        order,

        productsData,
        pages,
        current_page,
        total_orders
    };
}

const OrderDetail = connect(mapStateToProps, mapDispatchToProps)(CheckoutCart);
export default withRouter(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/CheckoutCart.jsx